import React, { useMemo } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react';

import { store } from 'Models/Store';
import LoginFlow from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/LoginStep/LoginFlow';
import { themeStore } from 'Models/ThemeStore';
import useDeviceDetect from 'Hooks/useDeviceDetect';

function LoginPage() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { isMobile } = useDeviceDetect();

	const redirectParam = searchParams.get('redirect') ?? '';
	const claimVoucherCode = useMemo(() => {
		try {
			if (redirectParam.includes('/claim-voucher')) {
				const url = new URL(redirectParam, window.location.origin);
				return url.searchParams.get('code') ?? '';
			}
		} catch {
			/* ignore parse errors */
		}
		return '';
	}, [redirectParam]);

	if (store.userData) {
		return <Navigate to="/" replace />;
	}

	return (
		<div className="login-page">
			<Link className="logo-link" to="/home">
				<img
					src={isMobile ? themeStore.logoSecondaryLightURL : themeStore.logoPrimaryLightURL}
					alt="Company Logo"
				/>
			</Link>
			<div
				className="top-section"
				style={{
					backgroundImage: `url(${themeStore.loginBackgroundImageURL})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			/>
			<div className="bottom-section" />
			<div className="center-section">
				<LoginFlow
					afterLoginSuccess={() => {
						if (redirectParam) {
							navigate(redirectParam);
						} else if (store.isStaff) {
							navigate('/ferry-schedule');
						} else {
							navigate('/');
						}
					}}
					voucherCode={claimVoucherCode || undefined}
					registrationMessage={
						claimVoucherCode
							? "Your voucher has been claimed! We've sent a verification email to your inbox. Verify your account and log in to view your voucher."
							: undefined
					}
				/>
			</div>
		</div>
	);
}

export default observer(LoginPage);
